const HPActionItemUrls =
{
    Completed: 'app/notificationCenter/modal/training/complete/complete.html',
};

export default HPActionItemUrls;



// WEBPACK FOOTER //
// ./src/app/config/constants/ActionItemUrls.constant.js